import React from 'react';
import * as S from './style';
import {
  ContentsContainer,
  ItemInfo,
  ItemInfoContainer,
  Row,
  FileImg,
  Label,
} from 'components';
import FormProfile, {
  Props as FormProfileProps,
} from 'components/molecules/FormProfile';
import ItemInfoBtn, {
  Props as ItemInfoBtnProps,
} from 'components/molecules/ItemInfoBtn';

import {
  TITLE_COMP_INFO,
  ITEM_INFO_SERVICE_LOCATION,
  ITEM_INFO_INTRODUCE,
  TITLE_BUSINESS_INFO,
  ITEM_INFO_BUSINESS_REGISTRATION,
  TITLE_PROFILE,
  LABEL_CARRIERYEAR,
  LABEL_EMAIL_ADDR,
  LABEL_BIRTHDAY,
  LABEL_SERVICE_IMAGE,
  LABEL_SERVICE_NAME,
} from 'commons/ZimssaString';

interface Props {
  serviceName: string;
  serviceImage: string;
  profile: FormProfileProps;
  birthday: string;
  carrierYear: string;
  email: string;
  location: string;
  introduce: string;
  businessRegistration: ItemInfoBtnProps;
}
function ServiceInfo({ ...props }: Props): React.ReactElement {
  return (
    <S.ServiceInfo>
      <ContentsContainer title={TITLE_PROFILE}>
        <FormProfile {...props.profile} />
        <ItemInfoContainer>
          <ItemInfo title={LABEL_BIRTHDAY} contents={props.birthday} bold />
          <ItemInfo title={LABEL_CARRIERYEAR} contents={props.carrierYear} bold />
          <ItemInfo title={LABEL_EMAIL_ADDR} contents={props.email} bold />
        </ItemInfoContainer>
      </ContentsContainer>
      <ContentsContainer title={TITLE_COMP_INFO}>
        <ItemInfoContainer>
          {props.serviceImage ? (
            <Row>
              <Label
                color={'gray_opacity_600'}
                fontStyle={'body2'}
                contents={LABEL_SERVICE_IMAGE}
              />
              <FileImg
                inputName={''}
                imgDir={''}
                isDeleteBtn={false}
                value={props.serviceImage}
              />
            </Row>
          ) : null}
          <ItemInfo title={LABEL_SERVICE_NAME} contents={props.serviceName} bold />
          <ItemInfo
            title={ITEM_INFO_SERVICE_LOCATION}
            contents={props.location}
            bold
          />
          <ItemInfoBtn title={ITEM_INFO_INTRODUCE} contents={props.introduce} />
        </ItemInfoContainer>
      </ContentsContainer>
      <ContentsContainer title={TITLE_BUSINESS_INFO}>
        <ItemInfoContainer>
          <ItemInfoBtn
            title={ITEM_INFO_BUSINESS_REGISTRATION}
            {...props.businessRegistration}
          />
        </ItemInfoContainer>
      </ContentsContainer>
    </S.ServiceInfo>
  );
}

export default ServiceInfo;
